<ion-item [button]="button" [detail]="detail" [disabled]="disabled" [routerLink]="routerLink">
  <ion-avatar slot="start" class="user-avatar">
    <div class="thumbnail-placeholder"></div>
  </ion-avatar>
  <ion-label>
    <h2>{{ getMemberDisplayName(member) }}</h2>
  </ion-label>
  <ion-badge slot="end" [color]="getRoleBadgeColor(member.role)">{{
    getRoleDisplay(member.role)
  }}</ion-badge>
</ion-item>
